import styled, { keyframes } from 'styled-components';

export const FADE_DURATION_MS = 200;

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const fadeOut = keyframes`
  from { opacity: 1; }
  to   { opacity: 0; }
`;

export const Overlay = styled.div<{ $isClosing: boolean }>`
  position: fixed;
  inset: 0;
  z-index: ${({ theme }) => theme.zIndex.modal};
  background-color: ${({ theme }) => theme.colors.background};
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: env(safe-area-inset-bottom);
  animation: ${({ $isClosing }) => ($isClosing ? fadeOut : fadeIn)} ${FADE_DURATION_MS}ms ease
    forwards;
`;

export const Header = styled.div`
  position: relative;
  flex-shrink: 0;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  box-shadow: ${({ theme }) => theme.shadows.sm};
`;

export const BackButton = styled.button`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  min-width: 44px; /* タッチターゲット確保 */
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
`;

export const Title = styled.h2`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Grid = styled.div<{ $selectionMode: boolean }>`
  flex: 1;
  overflow-y: auto;
  display: grid;
  /* minmax(0, 1fr) で aspect-ratio 由来の自動最小サイズによる列の溢れを防ぐ */
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1px;
  align-content: start; /* 写真が少ない時に行が縦方向へ分散しないよう上詰め */
  /* 選択モード時は保存バーに最下段が隠れないよう下部パディングを確保 */
  padding-bottom: ${({ $selectionMode }) => ($selectionMode ? '68px' : '0')};
`;

export const Cell = styled.div<{ $imageUrl: string }>`
  position: relative; /* チェックボックスの絶対配置基準 */
  aspect-ratio: 1;
  min-width: 0; /* グリッドアイテムの自動最小サイズを解除（列の溢れ防止） */
  background-image: url("${({ $imageUrl }) => $imageUrl}");
  background-size: cover;
  background-position: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent; /* タップ時のデフォルト暗転を無効化 */
  user-select: none; /* 長押し時のテキスト選択を抑止 */
  -webkit-touch-callout: none; /* 長押し時の画像コールアウトを抑止 */
`;

export const Checkbox = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none; /* トグルはセル側の onClick で処理する */
`;

export const SaveBar = styled.div<{ $visible: boolean }>`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background-color: #ffffff;
  box-shadow: ${({ theme }) => theme.shadows.sm};
  padding: 12px 24px calc(12px + env(safe-area-inset-bottom));
  transform: translateY(${({ $visible }) => ($visible ? '0' : '100%')});
  transition: transform 0.3s ease-out;
`;

export const SaveBarButton = styled.button`
  width: 100%;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 8px 12px;
  background-color: ${({ theme }) => theme.colors.primary};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  color: #ffffff;
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  box-shadow: ${({ theme }) => theme.shadows.md};
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
